/**
 * When user lands with ?bfe=1 but is not logged in, we store this so that after
 * they log in we can append bfe=1 to the redirect URL and claim the bonus.
 */
const BFE_PENDING_KEY = "c8_bfe_pending";

export function setBfePending(): void {
  try {
    sessionStorage.setItem(BFE_PENDING_KEY, "1");
  } catch {
    // ignore
  }
}

/**
 * If the user had bfe=1 pending (arrived from email link while logged out),
 * returns the query string to append to the redirect URL (?bfe=1 or &bfe=1)
 * and clears the pending flag. Otherwise returns "".
 */
export function consumeBfePendingParam(redirectUrl: string): string {
  try {
    const pending = sessionStorage.getItem(BFE_PENDING_KEY) === "1";
    if (pending) {
      sessionStorage.removeItem(BFE_PENDING_KEY);
      return redirectUrl.includes("?") ? "&bfe=1" : "?bfe=1";
    }
  } catch {
    // ignore
  }
  return "";
}
